import { render, staticRenderFns } from "./storage-content.vue?vue&type=template&id=a20a9950"
import script from "./storage-content.vue?vue&type=script&lang=js"
export * from "./storage-content.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports